module.exports = __webpack_public_path__ + "static/img.e66c4cfd.png";